<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(`common.history`) }}</h3>
      </div>
      <div class="box-body">
        <div>
          <ul class="nav nav-tabs">
            <li class="active" @click="onClickTabSelect(1)">
              <a data-toggle="tab" href="#apartmentHistory"
                ><b>{{ $t("module.perm_module_apartment") }}</b></a
              >
            </li>
            <li @click="onClickTabSelect(2)">
              <a data-toggle="tab" href="#residentHistory"
                ><b>{{ $t("module.perm_module_apartment_resident") }}</b></a
              >
            </li>
          </ul>
          <div class="tab-content">
            <div id="apartmentHistory" class="tab-pane fade in active"></div>
            <div id="residentHistory" class="tab-pane fade"></div>
          </div>
        </div>
        <div>
          <lte-table
            :hdBackground="hdBackground"
            :data="gridProjectHistoryDataList"
            :columns="gridColumns"
            search_filter="left-search"
            :useFilter="useFilter"
            :actions="actions"
            :boxStyle="boxStyle"
            :row_mouse_pointer="false"
          ></lte-table>
          <div
            v-if="gridProjectHistoryDataList.length > 0"
            class="box-footer clearfix"
            style="display:contents; padding: 0 5px"
          >
            <paginator
              :totalItem="paginateData.totalItem"
              :currentPage="paginateData.currentPage"
              :pageSize="paginateData.pageSize"
              :totalPage="paginateData.totalPage"
              @onpaginate="onPagination"
            />
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import LTETable from "@/components/LTETable.vue";
import Loading from "vue-loading-overlay";
import { mapActions, mapGetters } from "vuex";
import utils from '@/lib/utils';
import i18n from "../../lang";
import constants from "@/lib/constantsData";
import Enum from "../../../enum/enum";
export default {
  components: {
    "lte-table": LTETable,
    paginator: Paginator,
    loading: Loading
  },
  props: {
    apartmentId: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    useFilter: false,
    boxStyle: false,
    hdBackground:
      "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
    tblBorder: "border: 1px solid orange",
    actions: null,
    gridColumns: [
      { text: "common.nonumber", isHidden: true },
      { text: "project_history.full_name", isHidden: true },
      // { text: "project_history.project_name", isHidden: true },
      { text: "project_history.action", isHidden: true },
      // { text: "project_history.app", isHidden: true },
      { text: "project_history.description", isHidden: true },
      // { text: "project_history.module", isHidden: true },
      { text: "project_history.date_created", isHidden: true }
    ],
    gridProjectHistoryDataList: [],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    paginatorItem: {
      commit_function: "GET_PROJECT_HISTORY_LIST"
    },
    tabSelect: 1,
    tabSelectModuleName: Enum.ApartmentHistoryModuleName.PERM_MODULE_APARTMENT,
    isLoading: false
  }),
  watch: {
    PROJECT_HISTORY_LIST: function() {
      let paginate = this.PROJECT_HISTORY_LIST.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.PROJECT_HISTORY_LIST.results;
      this.gridProjectHistoryDataList = [];
      data.forEach((row, i) => {
        let id = row.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let full_name = utils.getFullName(
          row.user_first_name,
          row.user_last_name,
          i18n.locale
        );
        let project_name = row.project_name;
        // let action = this.$t(
        //   "project_history.action_description[" + row.action + "]"
        // );
        let action = this.checkAction(row.action);
        let app = utils.getApplicationName(constants.applicationTypes, row.app);
        let description = row.description;
        let module = this.$t("module." + row.module + "");
        let date_created = utils.formatSqlDate(row.date_created, null, constants.dateOptions.format_date_time);

        let data = {
          id: id,
          "common.nonumber": nonumber,
          "project_history.full_name": full_name,
          "project_history.project_name": project_name,
          "project_history.action": action,
          "project_history.app": app,
          "project_history.description": description,
          "project_history.module": module,
          "project_history.date_created": date_created
        };
        this.gridProjectHistoryDataList.push(data);
      });
    },
    apartmentId: function() {
      if (this.apartmentId !== null && this.apartmentId !== 0) {
        this.getProjectHistory(1);
      }
    }
  },
  computed: {
    ...mapGetters([
      "PROJECT_HISTORY_LIST",
      "PAGINATION"
    ])
  },
  methods: {
    onClickTabSelect: function(value) {
      this.tabSelect = value;
      switch (value) {
        case 1:
          this.tabSelectModuleName =
            Enum.ApartmentHistoryModuleName.PERM_MODULE_APARTMENT;
          this.getProjectHistory(1);
          break;
        case 2:
          this.tabSelectModuleName =
            Enum.ApartmentHistoryModuleName.PERM_MODULE_APARTMENT_RESIDENT;
          this.getProjectHistory(1);
          break;
        default:
          break;
      }
    },
    checkAction: function(action) {
      if (action == 0) return this.$t(`project_history.action_description[0]`);
      if (action == 1) return this.$t(`project_history.action_description[1]`);
      if (action == 2) return this.$t(`project_history.action_description[2]`);
      if (action == 3) return this.$t(`project_history.action_description[3]`);
    },
    onPagination: function(data) {
      this.getProjectHistory(data);
    },
    getProjectHistory: function(page) {
      const data = {
        params: {
          page: page,
          apartmentId: this.apartmentId,
          moduleName: this.tabSelectModuleName,
          page_size: 15
        }
      };
      this.isLoading = true
      this.GET_PROJECT_HISTORY_LIST(data)
        .then(
          function() {
            this.isLoading = false
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    ...mapActions([
      "GET_PROJECT_HISTORY_LIST"
    ])
  },
  created() {
    if (this.apartmentId !== null && this.apartmentId !== 0) {
      this.getProjectHistory(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  background: #337ab7;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentHistory.vue